import {
  SET_AUTO_FILL,
  LOAD_AUTO_FILL } from '../../action-types/ui/setAutoFill';

export const setAutoFill = setTrue => ({
  type: SET_AUTO_FILL,
  setTrue,
});

export const loadAutoFill = status => ({
  type: LOAD_AUTO_FILL,
  status,
});




// WEBPACK FOOTER //
// ./src/redux/actions/ui/setAutoFill.js